import { Divider, Paper, Typography } from "@mui/material";
import { Fragment } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import LensProductItem from "./lens-product-item";

export const LensProductSection = () => {
  const { control, watch } = useFormContext();

  const salesOrderLensProducts = watch("salesOrderLensProducts");

  const { remove } = useFieldArray({
    control,
    name: "salesOrderLensProducts",
  });

  return (
    <Paper sx={{ p: 2.5, borderRadius: 2 }}>
      <Typography variant="h6">Pesanan Lab.</Typography>
      {!salesOrderLensProducts || salesOrderLensProducts.length === 0 ? (
        <Typography
          sx={{
            color: "text.secondary",
            py: 1,
            textAlign: "center"
          }}>
          Tidak ada data
        </Typography>
      ) : (
        salesOrderLensProducts.map((lensProduct, index) => (
          <Fragment key={index}>
            {index != 0 && <Divider sx={{ my: 2 }} />}
            <LensProductItem
              index={index}
              lensProduct={lensProduct}
              onDelete={() => remove(index)}
            />
          </Fragment>
        ))
      )}
    </Paper>
  );
};

export default LensProductSection;
